import { render, staticRenderFns } from "./player-form-page.vue?vue&type=template&id=0b578a6d&"
import script from "./player-form-page.vue?vue&type=script&lang=js&"
export * from "./player-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports